import { render, staticRenderFns } from "./base_layout.vue.js?vue&type=template&id=2372e27a!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./base_layout.vue?vue&type=template&id=2372e27a"
import script from "./base_layout.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./base_layout.vue?vue&type=script&lang=js"
export * from "./base_layout.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./base_layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports